import { createSlotRecipe } from './runtime';

const dialogConfig = {"name":"dialog","slots":["trigger","backdrop","positioner","content","title","description","closeTrigger","backdrop","content"]}

export const dialog = /* @__PURE__ */ createSlotRecipe(dialogConfig)